import script from "./UtmMulti.vue?vue&type=script&setup=true&lang=js"
export * from "./UtmMulti.vue?vue&type=script&setup=true&lang=js"

import "./UtmMulti.vue?vue&type=style&index=0&id=0efb1d8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0efb1d8e"]])

export default __exports__